import {showNotification} from '@mantine/notifications'
import type {Err, OK} from 'shared/promise'
import {match, P} from 'ts-pattern'

export const showError = (
  error:
    | {
        message?: string
      }
    | string,
  title?: string
) => {
  console.warn('showed an error notification:', error)
  return showNotification({
    color: 'red',
    title,
    message: match(error)
      .with(P.string, s => s)
      .with({message: P.string}, e => e.message)
      .otherwise(e => e.toString()),
    autoClose: false
  })
}

export const okOrShowError = <T, E extends {message: string}>(r: OK<T> | Err<E>, title?: string) => {
  if (r.ok) return r
  showError(r.message, title)
  return r
}
